<template>

    <!-- <el-card class="material-list-card">
            <el-table :data="displayMaterialList" border stripe height="60vh" v-loading="loading"
                @selection-change="handleSelectionChange" ref="materialTable">
               
                <el-table-column type="selection" reserve-selection width="55"></el-table-column>

                <el-table-column prop="materialName" label="物料名称" align="center"></el-table-column>
                <el-table-column prop="room" label="功能间" align="center"></el-table-column>

                <el-table-column prop="num" label="采购数量" align="center">
                    <template #default="scope">
                        {{ scope.row.num || 0 }}
                    </template>
</el-table-column>
<el-table-column prop="unit" label="单位" align="center"></el-table-column>
<el-table-column prop="orderNumber" label="订单号" align="center"></el-table-column>
<el-table-column prop="taskNumber" label="任务单号" align="center"></el-table-column>
</el-table>

</el-card> -->

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">需求物料</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">物料名称</div>
                    <div class="header-item">功能间</div>
                    <div class="header-item">采购数量</div>
                    <div class="header-item">订单号</div>


                    <div class="header-item">任务单号</div>

                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in displayMaterialList" :key="index">
                            <div class="body-item">{{ item.materialName }}</div>
                            <div class="body-item">{{ item.room }}</div>

                            <div class="body-item"> {{ item.num }}{{ item.unit }}</div>

                            <div class="body-item"> {{ item.orderNumber }}</div>
                            <div class="body-item"> {{ item.taskNumber }}</div>

                        </div>
                        <div class="empty-tip" v-if="displayMaterialList.length === 0">
                            暂无数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>

</template>

<script>
import { getRequiredMaterials, calculateList } from "@/api/RequiredMaterials";

export default {

    data() {
        return {
            // 搜索表单
            searchForm: {
                materialName: "",
                materialType: "",
                materialCode: "",
            },
            // 物料列表数据
            allMaterialList: [], // 存储全量物料数据（仅初始化加载一次）
            filteredMaterialList: [], // 前端过滤后的物料数据
            displayMaterialList: [], // 当前页显示的物料数据
            total: 0, // 总条数
            currentPage: 1,
            pageSize: 10,
            loading: false,
            // 详情弹窗控制
            detailVisible: false,
            currentMaterial: null,
            // 选中的物料数组
            selectedMaterials: [],
        };
    },
    mounted() {
        this.loadAllMaterials(); // 初始化加载全量数据
    },
    methods: {
        send() {
            calculateList().then(response => {
                console.log(response);
                this.$message.success(response.message || '操作成功');
            }).catch(error => {
                console.error('calculateList接口调用失败:', error);
                this.$message.error('生成采购单失败，请重试');
            })
        },

        // 【核心修改】仅加载一次全量物料数据（无分页/查询参数）
        async loadAllMaterials() {
            this.loading = true;
            try {
                // 仅传递userId，不传递任何分页/查询参数
                const params = {
                    userId: localStorage.getItem("userId"),
                };

                const response = await getRequiredMaterials(params);
                console.log('全量物料数据:', response);

                // 存储全量数据
                this.allMaterialList = Array.isArray(response.data) ? response.data :
                    (response.data?.list || []);
                // 初始化过滤（显示全部）
                this.filteredMaterialList = [...this.allMaterialList];
                // 更新总数并执行分页
                this.total = this.filteredMaterialList.length;
                this.paginateData();

            } catch (error) {
                console.error("加载全量物料数据异常:", error);
                this.$message.error("网络异常，无法加载物料数据");
                this.allMaterialList = [];
                this.filteredMaterialList = [];
                this.displayMaterialList = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        // 【核心新增】前端物料名称过滤逻辑
        filterMaterials() {
            if (this.allMaterialList.length === 0) {
                this.filteredMaterialList = [];
                this.total = 0;
                this.paginateData();
                return;
            }

            // 物料名称模糊过滤（不区分大小写）
            let filtered = [...this.allMaterialList];
            const keyword = this.searchForm.materialName.trim().toLowerCase();
            if (keyword) {
                filtered = filtered.filter(item =>
                    item.materialName && item.materialName.toLowerCase().includes(keyword)
                );
            }

            // 更新过滤后的数据和总数
            this.filteredMaterialList = filtered;
            this.total = filtered.length;
            // 重新分页
            this.paginateData();
        },

        // 【新增】输入框实时过滤
        handleInputSearch() {
            this.currentPage = 1; // 输入时重置到第一页
            this.filterMaterials();
        },

        // 【修改】查询按钮点击（仅前端过滤）
        handleSearch() {
            this.currentPage = 1;
            this.filterMaterials();
        },

        // 前端分页计算
        paginateData() {
            if (this.filteredMaterialList.length === 0) {
                this.displayMaterialList = [];
                return;
            }
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayMaterialList = this.filteredMaterialList.slice(startIndex, endIndex);
        },

        // 重置搜索条件
        resetSearch() {
            this.searchForm = {
                materialName: "",
                materialType: "",
                materialCode: "",
            };
            this.currentPage = 1;
            // 恢复显示全量数据
            this.filteredMaterialList = [...this.allMaterialList];
            this.total = this.filteredMaterialList.length;
            this.paginateData();
        },

        // 【修改】分页大小改变（纯前端）
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // 切换页大小时重置页码
            this.paginateData(); // 仅前端重新分页
            // 滚动到表格顶部
            const tableEl = this.$refs.materialTable?.$el;
            if (tableEl) tableEl.scrollTop = 0;
        },

        // 【修改】当前页改变（纯前端）
        handleCurrentChange(page) {
            this.currentPage = page;
            this.paginateData(); // 仅前端重新分页
            // 滚动到表格顶部
            const tableEl = this.$refs.materialTable?.$el;
            if (tableEl) tableEl.scrollTop = 0;
        },

        // 查看物料详情
        viewDetail(material) {
            this.currentMaterial = { ...material };
            this.detailVisible = true;
        },

        // 多选框选中事件
        handleSelectionChange(val) {
            this.selectedMaterials = val;
            console.log('选中的物料:', this.selectedMaterials);
        },
    },
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>